module.exports = __webpack_public_path__ + "img/banner.359dd830.png";